export function isDisabled(contract, signature) {
  return contract.signed_date || signature?.status !== 'pending'
}
